import type { ObjectSchema } from "yup";
import { array, lazy, mixed, number, object, string } from "yup";

export enum InvoiceType {
  Standard = "standard",
  Correction = "correction",
}

export enum InvoiceStatus {
  Draft = "draft",
  Processing = "processing",
  Issued = "issued",
  PartiallyPaid = "partially_paid",
  Paid = "paid",
  ProcessingFailed = "processing_failed",
  Corrected = "corrected",
  Cancelled = "cancelled",
}

export interface InvoiceResource {
  uuid: string;
  number: string | null;
  type: InvoiceType;
  status: InvoiceStatus;
  currency: string;
  totalNetAmount: number;
  totalDiscountAmount: number;
  totalVatAmount: number;
  totalGrossAmount: number;
  totalPaidAmount: number;
  billingPeriodStart: string | null;
  billingPeriodEnd: string | null;
  issuedAt: string | null;
  dueAt: string | null;
  paidAt: string | null;
  pdfUrl: string | null;
  corrections: InvoiceResource[];
}

const buildInvoiceResourceSchema = (): ObjectSchema<InvoiceResource> =>
  object({
    uuid: string().required(),
    number: string().nullable().default(null),
    type: mixed<InvoiceType>()
      .oneOf(Object.values(InvoiceType) as InvoiceType[])
      .required(),
    status: mixed<InvoiceStatus>()
      .oneOf(Object.values(InvoiceStatus) as InvoiceStatus[])
      .required(),
    currency: string().required(),
    totalNetAmount: number().integer().required(),
    totalDiscountAmount: number().integer().required(),
    totalVatAmount: number().integer().required(),
    totalGrossAmount: number().integer().required(),
    totalPaidAmount: number().integer().required(),
    billingPeriodStart: string().nullable().default(null),
    billingPeriodEnd: string().nullable().default(null),
    issuedAt: string().nullable().default(null),
    dueAt: string().nullable().default(null),
    paidAt: string().nullable().default(null),
    pdfUrl: string().nullable().default(null),
    corrections: array()
      .of(lazy(() => buildInvoiceResourceSchema()))
      .required(),
  }) as ObjectSchema<InvoiceResource>;

export const invoiceResourceSchema = buildInvoiceResourceSchema();
